export default __webpack_public_path__ + "static/media/Money.a663fb0c.svg";